import React from 'react';
import PropTypes from 'prop-types';

function TouchPad({ active, activeColor, border, color }) {
  return (
    <>
      <path
        d="M389.064 105.808C389.174 105.69 389.293 105.683 389.424 105.688C390.413 105.72 391.998 105.737 392.792 105.745C393.345 105.751 396.584 105.76 399.716 105.769L400.261 105.768C403.215 105.76 406.119 105.751 406.64 105.745C407.434 105.737 409.021 105.72 410.009 105.688C410.14 105.684 410.259 105.689 410.368 105.808C420.293 105.855 434.316 105.978 448.339 106.395C466.449 106.934 484.344 107.961 498.849 109.016C513.353 110.071 524.466 111.152 531.523 111.951C538.58 112.75 541.58 113.268 547.607 114.228L550.576 119.03L553.455 135.317L550.576 151.727L546.545 173.896L537.137 219.098L537.04 236.963C537.004 237.508 536.746 238.378 536.401 240.239C536.229 241.17 536.183 242.439 535.807 243.765C535.43 245.09 534.921 246.594 534.219 248.233C533.516 249.872 532.62 251.648 531.538 253.483C530.456 255.318 528.819 257.043 527.37 258.921C525.922 260.8 524.664 262.831 522.897 264.616C521.13 266.402 519.223 268.114 517.216 269.691C515.209 271.267 513.101 270.222 510.948 271.473C508.795 272.725 506.596 273.784 504.406 274.594C503.311 274.999 502.219 275.342 500.92 275.633C499.621 275.924 498.114 276.164 496.193 276.362C494.272 276.56 491.936 276.717 488.975 276.845C486.014 276.972 482.429 277.069 478.011 277.147C469.174 277.302 457.006 277.38 445.109 277.418C433.212 277.456 421.587 277.456 413.836 277.456C401.39 277.456 400.681 277.46 399.93 277.464L399.779 277.465L399.695 277.464C398.909 277.459 398.538 277.456 385.721 277.456C377.971 277.456 366.345 277.456 354.447 277.418C342.55 277.379 330.382 277.302 321.545 277.147C317.127 277.07 313.542 276.972 310.581 276.845C307.62 276.717 305.284 276.56 303.363 276.362C301.442 276.164 299.935 275.924 298.636 275.633C297.337 275.342 296.245 274.999 295.15 274.594C292.96 273.784 290.761 272.725 288.608 271.473C286.455 270.222 284.348 268.779 282.341 267.202C280.333 265.624 278.427 266.402 276.66 264.616C274.894 262.831 273.848 260.227 272.4 258.349C270.952 256.471 269.562 254.977 268.48 253.142L268.358 252.934C267.328 251.19 266.455 249.709 265.779 248.132C265.077 246.493 264.849 244.769 264.472 243.443C264.095 242.117 263.932 240.809 263.759 239.878C263.415 238.017 262.992 237.781 262.956 237.236L262.421 217.37L257.774 196.065L251.44 165.547L249.424 157.774L246.833 141.939L248.273 122.073L249.424 119.03L251.825 114.228C257.852 113.268 260.854 112.75 267.911 111.951C274.967 111.152 286.078 110.071 300.583 109.016C315.088 107.961 332.984 106.934 351.093 106.395C365.115 105.978 379.139 105.855 389.064 105.808Z"
        fill={active ? activeColor : color}
      />
      <path
        d="M550.351 118.597C550.351 118.597 549.937 123.943 549.937 130.643C549.937 133.791 548.845 142.088 547.187 153.325C551.825 153.325 551.313 153.321 554.7 153.321C555.098 150.618 555.496 147.943 555.894 145.209C556.408 141.68 556.886 138.208 556.928 134.451C556.932 133.989 556.87 129.806 555.979 127.469C554.137 122.637 550.351 118.597 550.351 118.597ZM249.394 118.598C249.389 118.603 245.608 122.64 243.766 127.469C242.875 129.806 242.812 133.989 242.817 134.451C242.859 138.208 243.337 141.68 243.851 145.209C244.253 147.964 244.652 150.66 245.053 153.384C247.487 153.366 249.938 153.351 252.558 153.344C250.898 142.096 249.808 133.793 249.808 130.642C249.808 123.945 249.394 118.604 249.394 118.598Z"
        fill="#ADB0B7"
      />
      <path
        d="M249.324 127.646C249.324 127.646 245.536 130.534 243.693 133.987C242.801 135.658 242.738 138.646 242.743 138.976C242.785 141.662 243.264 144.143 243.778 146.665C250.061 177.454 256.234 205.249 262.205 236.47L263.073 239.182L263.088 239.493C263.576 244.207 265.477 248.94 267.913 253.164L268.093 253.628L268.411 254.017C271.417 258.379 274.641 262.802 278.7 266.8L279.154 267.207L279.638 267.597C283.95 270.941 288.553 274.121 293.632 276.388L294.072 276.634L294.56 276.734C298.444 278.27 303.182 278.708 307.308 279.069L307.654 279.14L308.005 279.237L399.3 280.017V280.026L399.872 280.021L400.443 280.026V280.017L491.738 279.237L492.09 279.14L492.435 279.069C496.561 278.707 501.3 278.27 505.184 276.734L505.672 276.634L506.112 276.388C511.192 274.121 515.794 270.941 520.106 267.597L520.59 267.207L521.045 266.8C525.103 262.802 528.327 258.379 531.333 254.017L531.651 253.628L531.832 253.164C534.268 248.94 536.168 244.207 536.657 239.493L536.668 239.182L537.536 236.47C543.508 205.249 549.68 177.454 555.963 146.665C556.477 144.143 556.956 141.662 556.998 138.976C557.002 138.646 556.94 135.658 556.048 133.987C554.205 130.534 550.417 127.646 550.417 127.646C550.417 127.646 550.003 131.467 550.003 136.255C550.003 140.933 545.36 161.257 540.47 184.112C536.551 202.431 532.661 222.376 529.485 237.198C528.612 241.269 525.728 251.879 514.96 260.422C511.047 263.528 500.005 269.127 491.923 269.127C463.15 269.127 430.825 269.061 400.279 269.059C400.009 269.059 399.728 269.059 399.459 269.059C368.912 269.061 336.587 269.127 307.814 269.127C299.733 269.127 288.691 263.528 284.777 260.422C274.009 251.879 271.124 241.269 270.251 237.198C267.076 222.376 263.186 202.431 259.268 184.112C254.379 161.257 249.735 140.933 249.735 136.255C249.735 131.467 249.321 127.646 249.321 127.646H249.324Z"
        fill="url(#paint0_linear_2_110)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2_110"
          x1="397.534"
          y1="279.626"
          x2="397.534"
          y2="165.718"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#333335" />
          <stop offset="1" stopColor={border} />
        </linearGradient>
      </defs>
      <g filter="url(#filter0_f_2_110)">
        <path
          d="M399.872 271.481C406.525 271.481 411.918 272.799 411.918 274.425C411.918 276.051 406.525 277.37 399.872 277.37C393.219 277.37 387.826 276.051 387.826 274.425C387.826 272.799 393.219 271.481 399.872 271.481Z"
          fill="#F2F2F2"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_2_110"
          x="386.407"
          y="270.062"
          width="26.9306"
          height="8.72733"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.709612"
            result="effect1_foregroundBlur_2_110"
          />
        </filter>
      </defs>
      <g filter="url(#filter1_f_2_110)">
        <path
          d="M399.872 273.408C402.171 273.408 404.035 273.863 404.035 274.425C404.035 274.987 402.171 275.443 399.872 275.443C397.573 275.443 395.709 274.987 395.709 274.425C395.709 273.863 397.573 273.408 399.872 273.408ZM399.872 273.408C402.171 273.408 404.035 273.863 404.035 274.425C404.035 274.987 402.171 275.443 399.872 275.443C397.573 275.443 395.709 274.987 395.709 274.425C395.709 273.863 397.573 273.408 399.872 273.408ZM399.872 273.408C402.171 273.408 404.035 273.863 404.035 274.425C404.035 274.987 402.171 275.443 399.872 275.443C397.573 275.443 395.709 274.987 395.709 274.425C395.709 273.863 397.573 273.408 399.872 273.408ZM399.872 273.408C402.171 273.408 404.035 273.863 404.035 274.425C404.035 274.987 402.171 275.443 399.872 275.443C397.573 275.443 395.709 274.987 395.709 274.425C395.709 273.863 397.573 273.408 399.872 273.408Z"
          fill="#F2F2F2"
        />
      </g>
      <defs>
        <filter
          id="filter1_f_2_110"
          x="395.495"
          y="273.194"
          width="8.75391"
          height="2.4631"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.106899"
            result="effect1_foregroundBlur_2_110"
          />
        </filter>
      </defs>
    </>
  );
}

TouchPad.propTypes = {
  active: PropTypes.bool,
  activeColor: PropTypes.string,
  border: PropTypes.string,
  color: PropTypes.string,
};

TouchPad.defaultProps = {
  active: false,
  activeColor: '#FF0000',
  border: '#0063FA',
  color: '#E6EAF0',
};

export default TouchPad;
